import { Col } from 'antd';
import { ReactNode } from 'react';
import { BsCalendarCheck, BsFileEarmarkText, BsCurrencyDollar } from 'react-icons/bs';

import { Logo } from '../Common/Logo/index';
import {
  Center,
  Content,
  FeatureCard,
  FeatureCards,
  Image,
  ImageCol,
  ImageOverlay,
  RowStyled,
  WelcomeSubtitle,
  WelcomeTitle,
} from './styles';

interface AuthLayoutProps {
  children: ReactNode;
}

export const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <RowStyled>
      <ImageCol xs={0} sm={0} md={15} lg={15}>
        <Image />
        <ImageOverlay>
          <WelcomeTitle>Bem-vindo ao Contlabs</WelcomeTitle>
          <WelcomeSubtitle>
            Gerencie e baixe os documentos da sua empresa
          </WelcomeSubtitle>
          <FeatureCards>
            <FeatureCard>
              <BsCalendarCheck />
              <span>Obrigações</span>
            </FeatureCard>
            <FeatureCard>
              <BsFileEarmarkText />
              <span>Documentos</span>
            </FeatureCard>
            <FeatureCard>
              <BsCurrencyDollar />
              <span>NFs</span>
            </FeatureCard>
          </FeatureCards>
        </ImageOverlay>
      </ImageCol>
      <Col xs={24} sm={24} md={9} lg={9}>
        <Center>
          <Content>
            <Logo height={35} />
            {children}
          </Content>
        </Center>
      </Col>
    </RowStyled>
  );
};
